import { cart } from './cart'
import { increment } from './increment'

export const search = (target) => {
  const el = {
    searchForm: target.querySelector('.search__form'),
    searchInput: target.querySelector('.search__input'),
    searchInputField: target.querySelector('.search__input input'),
    searchDropdown: target.querySelector('.search__dropdown'),
    searchDropdownButtons: target.querySelectorAll('.search__dropdown-button'),
    searchDropdownButtonAmount: target.querySelector('.search__dropdown-button-amount'),
    searchDropdownContent: target.querySelector('.search__dropdown-content'),
    searchMobileFiltersTriggerOpen: target.querySelector('.search__mobile-filters-trigger--open'),
    searchMobileFiltersTriggerClose: target.querySelector('.search__mobile-filters-trigger--close'),
  }

  const method = {
    init: () => {
      //el.searchInputField.value = window.location.search.slice(1).split('=')[1] || ''
      el.searchInputField.addEventListener('keyup', method.toggleOnKeyup)
      el.searchInput.addEventListener('click', method.toggleOnClick)
      el.searchMobileFiltersTriggerOpen.addEventListener('click', method.openMobileFilters)
      el.searchMobileFiltersTriggerClose.addEventListener('click', method.closeMobileFilters)

      el.searchDropdownButtons.forEach((button) => {
        button.addEventListener('click', () => el.searchForm.submit())
      })
    },

    isSearchActive: () => target.classList.contains('search--open'),

    isSearchPhraseLongEnough: () => el.searchInputField.value.length >= 3,

    closeDropdown: () => target.classList.remove('search--open'),

    openDropdown: () => target.classList.add('search--open'),

    closeMobileFilters: () => target.classList.remove('search--filters-open'),

    openMobileFilters: () => target.classList.add('search--filters-open'),

    toggleOnKeyup: (event) => {
      if (method.isSearchPhraseLongEnough()) {
        method.openDropdown()
        document.addEventListener('click', method.toggleOnOutsideClick)
        method.performSearch(event.target.value)
      } else {
        method.closeDropdown()
      }
    },

    toggleOnClick: (event) => {
      event.preventDefault()

      if (!method.isSearchPhraseLongEnough()) return

      if (method.isSearchActive()) {
        method.closeDropdown()
      } else {
        method.openDropdown()
        document.addEventListener('click', method.toggleOnOutsideClick)
        method.performSearch(event.target.value)
      }
    },

    toggleOnOutsideClick: (event) => {
      if (
        method.isSearchActive() &&
        !event.target.closest('.search--open .search__input') &&
        !event.target.closest('.search--open .search__dropdown') &&
        !event.target.closest('.search--open .search__button')
      ) {
        method.closeDropdown()
        document.removeEventListener('click', method.toggleOnOutsideClick)
      }
    },

    performSearch: async (searchPhrase) => {
      await fetch(`/umbraco/api/search/query?q=${searchPhrase}`, {
        method: el.searchForm.getAttribute('method'),
      })
        .then((response) => response.json())
        .then((response) => {
          if (response.total > 0) {
            el.searchDropdownContent.innerHTML = response.result
            el.searchDropdownButtonAmount.innerHTML = response.total

            el.searchDropdownContent
              .querySelectorAll('.product-card__form, .product-page__form')
              .forEach((form) => {
                form.addEventListener('submit', (event) => cart.addToCart(form, event))
              })

            el.searchDropdownContent.querySelectorAll('.increment').forEach((target) => increment(target))
            target.classList.remove('search--nothing-found')
          } else {
            el.searchDropdownContent.innerHTML = el.searchDropdownContent.dataset.nothingFoundText
            target.classList.add('search--nothing-found')
          }
        })
        .catch((ex) => {
          console.log(ex)
        })
    },
  }

  method.init()
}
